import * as React from 'react';

import { Header } from '../../components/Header';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../selectors/page';
import { EPageType } from '../../types/page';
import { useApplicationContext } from '../../utils/applicationContext';

interface IHeaderContainerProps {
  withBackground?: boolean;
}

export const HeaderContainer: React.FC<IHeaderContainerProps> = ({ withBackground = false }) => {
  const pageType = useSelector(selectPageType);
  const { config } = useApplicationContext();

  const aboutUsLink = React.useMemo(() => config.getStrict<string>('job-vacancies-frontend.aboutPageUrl'), [config]);

  return (
    <Header
      withBackground={withBackground}
      links={[
        {
          name: 'О нас',
          href: aboutUsLink,
          isActive: false,
        },
        {
          name: 'Вакансии',
          href: '/vacancies/',
          isActive: pageType === EPageType.Listing,
        },
      ]}
    />
  );
};

HeaderContainer.displayName = 'HeaderContainer';
